import { Component } from '@verndale/core'
import { createFocusTrap } from 'focus-trap'
import { disableBodyScroll, clearAllBodyScrollLocks, enableBodyScroll } from 'body-scroll-lock'
import { rovingIndex } from '@verndale/roving-ux'
import { focusableElements, KEYCODE, MEDIA_QUERIES, stringToBoolean } from '../utils'

class Module extends Component {
  setupDefaults() {
    this.dom = {
      $mobileMenuTrigger: this.el.querySelector('.header__mobile-top-trigger'),
      $mobileTopMenu: this.el.querySelector('.header__mobile-top'),
      $mobileMenu: this.el.querySelector('.header__mobile-menu'),
      $mobileCompanyNav: this.el.querySelector('.header__mobile-company-nav'),
      $mobileCompanyNavButton: this.el.querySelectorAll(
        '.header__mobile-company-nav button[aria-haspopup]'
      ),
      $mobileCompanyNestedLists: this.el.querySelectorAll('.header__mobile-nested-list'),
      $mobilePrimaryNav: this.el.querySelector('.header__mobile-primary-nav'),
      $mobilePrimaryNavButton: this.el.querySelectorAll(
        '.header__mobile-primary-nav .header__mobile-primary-nav-item'
      ),
      $mobilePrimaryNavItem: this.el.querySelectorAll('.header__mobile-primary-nav-item'),
      $mobilePrimaryNavNestedMenu: this.el.querySelectorAll(
        '.header__mobile-primary-nav-nested-menu'
      ),
      $mobilePrimaryNavNestedTrigger: this.el.querySelectorAll(
        '.header__mobile-primary-nav-nested-trigger'
      ),
      $mobilePrimaryNavItemBack: this.el.querySelectorAll('.header__mobile-primary-nav-item-back'),
      $mobilePrimaryNavNestedItemBack: this.el.querySelectorAll(
        '.header__mobile-primary-nav-nested-item-back'
      ),
      $mobilePrimaryNavNestedSubmenu: this.el.querySelectorAll(
        '.header__mobile-primary-nav-nested-submenu'
      ),
      $companyNav: this.el.querySelector('.header__company-nav'),
      $companyNavButton: this.el.querySelectorAll('.header__company-nav button[aria-haspopup]'),
      $primaryNav: this.el.querySelector('.header__primary-nav'),
      $primaryNavButton: this.el.querySelectorAll('.header__primary-nav button[aria-haspopup]'),
      $innerMenuHeader: this.el.querySelectorAll('.header__inner-menu-header'),
      $innerMenuHeaderButton: this.el.querySelectorAll(
        '.header__inner-menu-header button[role="tab"]'
      ),
      $innerMenuTabPanel: this.el.querySelectorAll('[role="tabpanel"]'),
      $companyNestedLists: this.el.querySelectorAll('.header__nested-list'),
      $innerMenu: this.el.querySelectorAll('.header__inner-menu'),
      $innerMenuLists: this.el.querySelectorAll('.header__inner-menu [role="tabpanel"] ul'),
      $innerMenuDirectLists: this.el.querySelectorAll('.header__inner-menu > ul'),
      $innerMenuLink: this.el.querySelectorAll('.header__inner-menu-link'),
      $headerSearchBtn: this.el.querySelector('.header__search-btn'),
      $headerSearchContainer: this.el.querySelector('.header__search-container-desktop')
    }

    this.navBackButton = ''

    const self = this

    this.mainFocusTrap = createFocusTrap(this.el, {
      escapeDeactivates: false,
      onActivate() {
        disableBodyScroll(self.el, {
          allowTouchMove: (el) => el.closest('.header__mobile-menu')
        })
      },
      onDeactivate() {
        clearAllBodyScrollLocks()
      }
    })

    this.$headerSearchBtnSvgs = this.dom.$headerSearchBtn.querySelectorAll('svg')

    this.addRovings()
    this.preventNestedBehaviour()
  }

  addListeners() {
    this.dom.$mobileMenuTrigger.addEventListener(
      'click',
      this.handleMobileMenuTriggerClick.bind(this)
    )
    this.dom.$mobileCompanyNavButton.forEach((button) =>
      button.addEventListener('click', this.handleMobileCompanyNavButtonClick.bind(this))
    )
    this.dom.$mobilePrimaryNavButton.forEach((button) =>
      button.addEventListener('click', this.handleMobilePrimaryNavButtonClick.bind(this))
    )
    this.dom.$mobilePrimaryNavItemBack.forEach((button) =>
      button.addEventListener('click', this.handleMobilePrimaryNavItemBackClick.bind(this))
    )
    this.dom.$mobilePrimaryNavNestedMenu.forEach((menu) =>
      menu.addEventListener('focusout', this.handleMobilePrimaryNavNestedMenuFocusOut.bind(this))
    )
    this.dom.$mobilePrimaryNavNestedItemBack.forEach((menu) =>
      menu.addEventListener('click', this.handleMobilePrimaryNavNestedItemBackClick.bind(this))
    )
    this.dom.$mobilePrimaryNavNestedTrigger.forEach((trigger) =>
      trigger.addEventListener('click', this.handleMobilePrimaryNavNestedTriggerClick.bind(this))
    )
    this.dom.$mobilePrimaryNavNestedSubmenu.forEach((trigger) =>
      trigger.addEventListener(
        'focusout',
        this.handleMobilePrimaryNavNestedSubmenuFocusOut.bind(this)
      )
    )
    this.dom.$companyNavButton.forEach((button) =>
      button.addEventListener('click', this.handleCompanyNavButtonClick.bind(this))
    )
    this.dom.$primaryNavButton.forEach((button) =>
      button.addEventListener('click', this.handlePrimaryNavButtonClick.bind(this))
    )
    this.dom.$innerMenuHeaderButton.forEach((button) =>
      button.addEventListener('click', (e) => this.activateTab(e.target))
    )
    this.dom.$innerMenu.forEach((menu) =>
      menu.addEventListener('focusout', this.handleInnerMenuFocusOut.bind(this))
    )
    this.dom.$primaryNav.addEventListener('focusout', this.handlePrimaryNavFocusOut.bind(this))
    window
      .matchMedia(`(min-width: ${MEDIA_QUERIES.TABLET_LANDSCAPE}px)`)
      .addEventListener('change', this.handleMediaQueryChange.bind(this))
    this.dom.$headerSearchBtn.addEventListener('click', this.toggleSearch.bind(this))
  }

  toggleSearch(e) {
    if (this.dom.$headerSearchContainer.hasAttribute('hidden')) {
      this.dom.$headerSearchContainer.removeAttribute('hidden')
      this.$headerSearchBtnSvgs[0].classList.add('header__search-svg-hidden')
      this.$headerSearchBtnSvgs[1].classList.remove('header__search-svg-hidden')
    } else {
      this.dom.$headerSearchContainer.setAttribute('hidden', true)
      this.$headerSearchBtnSvgs[1].classList.add('header__search-svg-hidden')
      this.$headerSearchBtnSvgs[0].classList.remove('header__search-svg-hidden')
    }
  }

  addRovings() {
    if (this.dom.$mobileCompanyNav?.querySelector('.header__mobile-company-nav-item')) {
      rovingIndex({
        element: this.dom.$mobileCompanyNav,
        target: '.header__mobile-company-nav-item'
      })
    }

    if (this.dom.$mobilePrimaryNav?.querySelector('.header__mobile-primary-nav-item')) {
      rovingIndex({
        element: this.dom.$mobilePrimaryNav,
        target: '.header__mobile-primary-nav-item'
      })
    }

    if (this.dom.$companyNav?.querySelector('.header__company-nav-item')) {
      rovingIndex({
        element: this.dom.$companyNav,
        target: '.header__company-nav-item'
      })
    }

    this.dom.$innerMenuHeader.forEach((innerMenu) => {
      if (innerMenu.querySelector('[role="tab"]')) {
        rovingIndex({
          element: innerMenu,
          target: '[role="tab"]',
          callback: this.activateTab.bind(this)
        })
      }
    })

    this.dom.$mobilePrimaryNavNestedSubmenu.forEach((menu) => {
      if (menu.querySelector('[role="menuitem"]')) {
        rovingIndex({
          element: menu,
          target: '[role="menuitem"]'
        })
      }
    })

    this.dom.$mobileCompanyNestedLists.forEach((list) => {
      if (list.querySelector('a')) {
        rovingIndex({
          element: list,
          target: 'a'
        })
      }
    })

    this.dom.$companyNestedLists.forEach((list) => {
      if (list.querySelector('a')) {
        rovingIndex({
          element: list,
          target: 'a'
        })
      }
    })

    this.dom.$mobilePrimaryNavNestedMenu.forEach((menu) => {
      if (menu.querySelector(':scope > li > [role="menuitem"]')) {
        rovingIndex({
          element: menu,
          target: ':scope > li > [role="menuitem"]'
        })
      }
    })

    this.dom.$innerMenuLists.forEach((menu) => {
      if (menu.querySelector('a')) {
        rovingIndex({
          element: menu,
          target: 'a'
        })
      }
    })

    this.dom.$innerMenuDirectLists.forEach((menu) => {
      if (menu.querySelector('a')) {
        rovingIndex({
          element: menu,
          target: 'a'
        })
      }
    })
  }

  activateTab(tab) {
    const panelId = tab.getAttribute('aria-controls')
    const panelEl = this.el.querySelector(`#${panelId}`)

    this.dom.$innerMenuHeaderButton.forEach((button) => {
      if (button.parentNode.parentNode === tab.parentNode.parentNode) {
        button.setAttribute('aria-selected', false)
      }
    })

    this.dom.$innerMenuTabPanel.forEach((panel) => {
      if (panel.parentNode === tab.parentNode.parentNode) {
        panel.hidden = true
      }
    })

    if (tab) tab.setAttribute('aria-selected', true)
    if (panelEl) panelEl.hidden = false
  }

  preventNestedBehaviour() {
    this.dom.$innerMenuHeader.forEach((innerMenu) => {
      const innerMenuHeader = innerMenu

      innerMenuHeader.addEventListener('focusin', (e) => e.stopPropagation())
      innerMenuHeader.addEventListener('keydown', (e) => {
        const selectedPanel = Array.from(this.dom.$innerMenuTabPanel).find((panel) => !panel.hidden)
        const links = selectedPanel?.querySelectorAll('a')

        switch (e.keyCode) {
          case KEYCODE.UP:
          case KEYCODE.DOWN:
          case KEYCODE.LEFT:
          case KEYCODE.RIGHT:
          case KEYCODE.HOME:
          case KEYCODE.END:
            e.stopPropagation()
            e.preventDefault()
            break
          case KEYCODE.TAB:
            e.stopPropagation()
            e.preventDefault()
            if (links?.length && !e.shiftKey) links[0].focus()
            break
          default:
            break
        }
      })
    })

    this.dom.$mobilePrimaryNavNestedSubmenu.forEach((menu) => {
      menu.addEventListener('focusin', (e) => e.stopPropagation())
      menu.addEventListener('keydown', (e) => {
        const backButton = e.currentTarget.querySelector(
          '.header__mobile-primary-nav-nested-item-back'
        )

        switch (e.keyCode) {
          case KEYCODE.UP:
          case KEYCODE.DOWN:
          case KEYCODE.LEFT:
          case KEYCODE.RIGHT:
          case KEYCODE.HOME:
          case KEYCODE.END:
            e.stopPropagation()
            e.preventDefault()
            break
          case KEYCODE.ESCAPE:
            e.stopPropagation()
            e.preventDefault()
            if (backButton) backButton.click()
            break
        }
      })
    })

    this.dom.$mobilePrimaryNavNestedItemBack.forEach((button) => {
      button.addEventListener('focusin', (e) => e.stopPropagation())
      button.addEventListener('keydown', (e) => {
        switch (e.keyCode) {
          case KEYCODE.UP:
          case KEYCODE.DOWN:
          case KEYCODE.LEFT:
          case KEYCODE.RIGHT:
          case KEYCODE.HOME:
          case KEYCODE.END:
            e.stopPropagation()
            e.preventDefault()
            break
          case KEYCODE.ESCAPE:
            e.stopPropagation()
            e.preventDefault()
            e.currentTarget.click()
            break
        }
      })
    })

    this.dom.$mobilePrimaryNavNestedTrigger.forEach((trigger) =>
      trigger.addEventListener('focusin', (e) => e.stopPropagation())
    )

    this.dom.$mobilePrimaryNavNestedMenu.forEach((menu) => {
      menu.addEventListener('focusin', (e) => e.stopPropagation())
      menu.addEventListener('keydown', (e) => {
        const backButton = e.target
          .closest('.header__mobile-primary-nav-nested-menu')
          ?.querySelector('.header__mobile-primary-nav-item-back')

        switch (e.keyCode) {
          case KEYCODE.UP:
          case KEYCODE.DOWN:
          case KEYCODE.LEFT:
          case KEYCODE.RIGHT:
          case KEYCODE.HOME:
          case KEYCODE.END:
            e.stopPropagation()
            e.preventDefault()
            break
          case KEYCODE.ESCAPE:
            e.stopPropagation()
            e.preventDefault()
            backButton?.click()
          default:
            break
        }
      })
    })

    this.dom.$innerMenuHeaderButton.forEach((button) =>
      button.addEventListener('keydown', (e) => {
        const trigger = Array.from(this.dom.$primaryNavButton).find((button) =>
          stringToBoolean(button.getAttribute('aria-expanded'))
        )

        if (e.keyCode === KEYCODE.ESCAPE || (e.keyCode === KEYCODE.TAB && e.shiftKey)) {
          trigger.setAttribute('aria-expanded', false)
          trigger.focus()
        }
      })
    )

    this.dom.$primaryNavButton.forEach((button) =>
      button.addEventListener('focusin', (e) => e.stopPropagation())
    )

    // mobile and desktop
    ;[...this.dom.$mobileCompanyNestedLists, ...this.dom.$companyNestedLists].forEach((list) => {
      const trigger = list.previousElementSibling
      const links = list.querySelectorAll('a')
      let keysSoFar = ''

      function clearKeysSoFar() {
        setTimeout(() => (keysSoFar = ''), 350)
      }

      list.addEventListener('focusin', (e) => e.stopPropagation())
      list.addEventListener('focusout', (e) => {
        if (e.relatedTarget === trigger) return
        if (!list.contains(e.relatedTarget) && trigger) {
          if (
            !e.relatedTarget?.classList.contains('header__company-nav') &&
            !e.relatedTarget?.classList.contains('header__mobile-company-nav')
          ) {
            trigger.setAttribute('aria-expanded', false)
          }
        }
      })
      list.addEventListener('keydown', (e) => {
        switch (e.keyCode) {
          case KEYCODE.UP:
          case KEYCODE.DOWN:
          case KEYCODE.LEFT:
          case KEYCODE.RIGHT:
          case KEYCODE.HOME:
          case KEYCODE.END:
            e.stopPropagation()
            e.preventDefault()
            break
          case KEYCODE.ESCAPE:
            e.preventDefault()
            if (trigger) {
              trigger.click()
              trigger.focus()
            }
            break
          default:
            keysSoFar += e.key
            if (keysSoFar) this.searchOptionToFocus(links, keysSoFar)
            clearKeysSoFar()
            break
        }
      })
    })

    this.dom.$innerMenuLink.forEach((link) => {
      link.addEventListener('focusin', (e) => e.stopPropagation())
      link.addEventListener('keydown', (e) => {
        const trigger = Array.from(this.dom.$primaryNavButton).find((button) =>
          stringToBoolean(button.getAttribute('aria-expanded'))
        )

        switch (e.keyCode) {
          case KEYCODE.ESCAPE:
            e.preventDefault()
            if (trigger) {
              trigger.setAttribute('aria-expanded', false)
              trigger.focus()
            }
            break
          default:
            break
        }
      })
    })

    this.dom.$innerMenuLists.forEach((list) => {
      list.addEventListener('focusin', (e) => e.stopPropagation())
      list.addEventListener('keydown', (e) => {
        const selectedTab = Array.from(this.dom.$innerMenuHeaderButton).find((button) =>
          stringToBoolean(button.getAttribute('aria-selected'))
        )

        switch (e.keyCode) {
          case KEYCODE.UP:
          case KEYCODE.DOWN:
          case KEYCODE.LEFT:
          case KEYCODE.RIGHT:
          case KEYCODE.HOME:
          case KEYCODE.END:
            e.stopPropagation()
            e.preventDefault()
            break
          case KEYCODE.ESCAPE:
            e.preventDefault()
            if (selectedTab) selectedTab.focus()
            break
          case KEYCODE.TAB:
            e.stopPropagation()
            if (e.shiftKey && selectedTab) {
              e.preventDefault()
              selectedTab.focus()
            }
          default:
            break
        }
      })
    })

    this.dom.$innerMenuDirectLists.forEach((list) => {
      list.addEventListener('focusin', (e) => e.stopPropagation())
      list.addEventListener('keydown', (e) => {
        const trigger = Array.from(this.dom.$primaryNavButton).find((button) =>
          stringToBoolean(button.getAttribute('aria-expanded'))
        )
        const nextLink = e.currentTarget.nextElementSibling

        switch (e.keyCode) {
          case KEYCODE.UP:
          case KEYCODE.DOWN:
          case KEYCODE.LEFT:
          case KEYCODE.RIGHT:
          case KEYCODE.HOME:
          case KEYCODE.END:
            e.stopPropagation()
            e.preventDefault()
            break
          case KEYCODE.ESCAPE:
            e.preventDefault()
            if (trigger) {
              trigger.setAttribute('aria-expanded', false)
              trigger.focus()
            }
            break
          case KEYCODE.TAB:
            e.stopPropagation()
            if (e.shiftKey && trigger) {
              e.preventDefault()
              if (trigger) trigger.focus()
            } else if (nextLink) {
              e.preventDefault()
              nextLink.focus()
            }
            break
          default:
            break
        }
      })
    })

    this.dom.$mobilePrimaryNavItemBack?.forEach((button) => {
      button.addEventListener('focusin', (e) => e.stopPropagation())
      button.addEventListener('keydown', (e) => {
        switch (e.keyCode) {
          case KEYCODE.UP:
          case KEYCODE.DOWN:
          case KEYCODE.LEFT:
          case KEYCODE.RIGHT:
          case KEYCODE.HOME:
          case KEYCODE.END:
            e.stopPropagation()
            e.preventDefault()
            break
          case KEYCODE.ESCAPE:
            button.click()
            break
          default:
            break
        }
      })
    })
  }

  searchOptionToFocus(options, keysSoFar) {
    const filteredOptions = Array.from(options).filter((option) =>
      option.textContent.toLowerCase().startsWith(keysSoFar)
    )

    if (filteredOptions?.length) {
      filteredOptions[0].focus()
    }
  }

  handleCompanyNavButtonClick(e) {
    const isOpen = stringToBoolean(e.target.getAttribute('aria-expanded'))

    Array.from(this.dom.$companyNavButton)
      .filter((button) => button !== e.target)
      .forEach((button) => button.setAttribute('aria-expanded', false))

    e.target.setAttribute('aria-expanded', !isOpen)

    if (!isOpen) this.openCompanyMenu(e.target)
  }

  handlePrimaryNavButtonClick(e) {
    const isOpen = stringToBoolean(e.target.getAttribute('aria-expanded'))

    Array.from(this.dom.$primaryNavButton).forEach((button) =>
      button.setAttribute('aria-expanded', false)
    )

    e.target.setAttribute('aria-expanded', !isOpen)

    if (!isOpen) this.openPrimaryMenu(e.target)
  }

  openCompanyMenu(button) {
    const menu = button.nextElementSibling
    const links = menu.querySelectorAll('a')

    if (links?.length) {
      const prevSelected = Array.from(links).find((link) => link.tabIndex === 0)

      if (prevSelected) prevSelected.focus()
    }
  }

  openPrimaryMenu(button) {
    const menu = button.nextElementSibling
    const focusable = menu?.querySelectorAll(focusableElements)

    if (focusable?.length) {
      focusable[0].focus()
    }
  }

  handleInnerMenuFocusOut(e) {
    const trigger = e.currentTarget.previousElementSibling

    if (e.relatedTarget === trigger) return
    if (!e.currentTarget.contains(e.relatedTarget)) trigger.setAttribute('aria-expanded', false)
  }

  handlePrimaryNavFocusOut(e) {
    if (!e.currentTarget.contains(e.relatedTarget)) {
      this.dom.$primaryNavButton.forEach((button) => button.setAttribute('aria-expanded', false))
    }
  }

  handleMobileMenuTriggerClick(e) {
    const isOpen = stringToBoolean(e.target.getAttribute('aria-expanded'))
    e.target.setAttribute('aria-expanded', !isOpen)
    this.dom.$mobileMenu.dataset.open = !isOpen

    if (!isOpen) {
      this.mainFocusTrap.activate()
    } else {
      this.mainFocusTrap.deactivate()
      this.dom.$mobileTopMenu.classList.remove('header__mobile-top--open')
      this.dom.$mobileMenu.classList.remove('header__mobile-top--submenu-open')
    }
  }

  handleMobileCompanyNavButtonClick(e) {
    const isOpen = stringToBoolean(e.target.getAttribute('aria-expanded'))

    Array.from(this.dom.$mobileCompanyNavButton)
      .filter((button) => button !== e.target)
      .forEach((button) => button.setAttribute('aria-expanded', false))
    e.target.setAttribute('aria-expanded', !isOpen)

    if (!isOpen) this.openCompanyMenu(e.target)
  }

  handleMediaQueryChange(e) {
    if (e.matches) {
      this.dom.$mobileMenuTrigger.setAttribute('aria-expanded', false)
      this.dom.$mobileMenu.dataset.open = false
      this.mainFocusTrap.deactivate()
    }
  }

  handleMobilePrimaryNavButtonClick(e) {
    const isOpen = stringToBoolean(e.target.getAttribute('aria-expanded'))

    Array.from(this.dom.$mobilePrimaryNavButton)
      .filter((button) => button !== e.currentTarget)
      .forEach((button) => button.setAttribute('aria-expanded', false))

    e.currentTarget.setAttribute('aria-expanded', !isOpen)

    if (isOpen) {
      this.dom.$mobileTopMenu.classList.remove('header__mobile-top--open')
      this.dom.$mobileMenu.classList.remove('header__mobile-top--submenu-open')
    } else {
      this.openMobilePrimaryNestedMenu(e.target)
      this.dom.$mobileTopMenu.classList.add('header__mobile-top--open')
      this.dom.$mobileMenu.classList.add('header__mobile-top--submenu-open')
    }
  }

  openMobilePrimaryNestedMenu(button) {
    const menu = button.nextElementSibling
    this.navBackButton = menu.querySelector('.header__mobile-primary-nav-item-back')
    const focusable = menu?.querySelectorAll(focusableElements)

    if (focusable?.length) focusable[0].focus()
    if (menu) disableBodyScroll(menu)
  }

  handleMobilePrimaryNavItemBackClick(e) {
    this.navBackButton.hidden = false
    const menu = e.target.closest('.header__mobile-primary-nav-nested-menu')
    const trigger = menu.previousElementSibling
    const activeTrigger = Array.from(this.dom.$mobilePrimaryNavItem).find(
      (item) => item.tabIndex === 0
    )
    this.dom.$mobileTopMenu.classList.remove('header__mobile-top--open')
    this.dom.$mobileMenu.classList.remove('header__mobile-top--submenu-open')

    if (menu) enableBodyScroll(menu)
    if (trigger) trigger.setAttribute('aria-expanded', false)
    if (activeTrigger) activeTrigger.focus()
  }

  handleMobilePrimaryNavNestedMenuFocusOut(e) {
    if (e.srcElement) {
      if (
        !e.currentTarget.contains(e.relatedTarget) &&
        !e.srcElement.classList.contains('header__mobile-primary-nav-nested-item-back')
      )
        this.handleMobilePrimaryNavItemBackClick(e)
    } else {
      if (!e.currentTarget.contains(e.relatedTarget)) this.handleMobilePrimaryNavItemBackClick(e)
    }
  }

  handleMobilePrimaryNavNestedTriggerClick(e) {
    const submenu = e.target.nextElementSibling
    this.navBackButton.hidden = true
    const backButton = submenu.querySelector('.header__mobile-primary-nav-nested-item-back')

    e.currentTarget.setAttribute('aria-expanded', true)
    if (backButton) backButton.focus()
    disableBodyScroll(submenu)
  }

  handleMobilePrimaryNavNestedItemBackClick(e) {
    const isOpen = stringToBoolean(e.currentTarget.getAttribute('aria-expanded'))
    const submenu = e.target.closest('.header__mobile-primary-nav-nested-submenu')
    const trigger = submenu.previousElementSibling
    const activeTrigger = Array.from(this.dom.$mobilePrimaryNavNestedTrigger).find(
      (item) => item.tabIndex === 0
    )

    this.navBackButton.hidden = false

    if (submenu) enableBodyScroll(submenu)
    if (trigger) trigger.setAttribute('aria-expanded', !isOpen)
    if (activeTrigger) activeTrigger.focus()
  }

  handleMobilePrimaryNavNestedSubmenuFocusOut(e) {
    const trigger = e.currentTarget.previousElementSibling

    if (!e.currentTarget.contains(e.relatedTarget)) {
      trigger.setAttribute('aria-expanded', false)
      this.navBackButton.focus()
      enableBodyScroll(e.currentTarget)
    }
  }
}

export default Module
